import "./About.css";
import {ReactComponent as LogoIcon} from "../../Asset/pages.svg"
import {ReactComponent as TranIcon} from "../../Asset/transparent.svg"

const sectionsData = [
  {
    title: "Efficiency",
    description:
      "Save time with on-demand connections between charterers and owners.",
  },
  {
    title: "Transparency",
    description: "Operate with confidence through clear, reliable information.",
  },
  {
    title: "Expertise",
    description: "Benefit from our deep understanding of maritime operations.",
  },
  {
    title: "Global Reach",
    description: "Connect with stakeholders worldwide, all in one place.",
  },
];

const About = () => {
  return (
    <div className="about">
      <div className="header">
        <div className="wrap">
            <LogoIcon/>
          <div className="box1">
          <p>Introduction</p>

          </div>
          <div className="box2">
          <h3>
            We simplify maritime logistics by connecting charterers and
            shipowners through an intuitive, technology-driven platform
          </h3>
          </div>
        </div>
      </div>


<div className="marquee-wrapper">
<div className="marquee">
      <div className="marquee__inner">
      <span>Scroll to Discover</span>
        <span className="dot">•</span>
        <span>Scroll to Discover</span>
        <span className="dot">•</span>
        <span>Scroll to Explore</span>

        {/* Duplicate to ensure seamless transition */}
        <span>Scroll to Discover</span>
        <span className="dot">•</span>
        <span>Scroll to Discover</span>
        <span className="dot">•</span>
        <span>Scroll to Explore</span>
      </div>
    </div>
</div>


      <div className="banner">
        <div className="wrapper">
        <p>
          We understand the challenges of the maritime industry, tight
          schedules, evolving regulations, and the need for reliable
          connections. That’s why we’ve designed a platform that brings
          efficiency to every transaction.
        </p>
        <p>
          We understand the challenges of the maritime industry, tight
          schedules, evolving regulations, and the need for reliable
          connections. That’s why we’ve designed a platform that brings
          efficiency to every transaction.
        </p>
        </div>
      </div>

      <div className="our-mission">
        <div className="box-1">
          <p>
            Our mission is to streamline vessel chartering and sales, making the
            process faster, easier, and more transparent for everyone involved.
          </p>
        </div>

        <div className="box-2">
          <p>
            Whether you're securing a charter or finalizing a vessel sale, our
            tools ensure seamless communication and smarter decision-making.
          </p>
          <p>
            With a focus on innovation and accessibility, we aim to empower
            businesses of all sizes. By leveraging cutting-edge technology and
            industry insights, we’re not just helping our users adapt to change,
            we’re driving the change.
          </p>
        </div>
      </div>

      <div className="tech">
        <div className="wrapper">
        <div className="header">
          <p>Why Choose Us?</p>
          <h3>
            Vatug Technology Limited is dedicated to{" "}
            <span>simplifying your journey</span> through the complexities of
            maritime logistics. Let us help you navigate the future, one
            connection at a time.
          </h3>
          <TranIcon/>
        </div>
        <div className="section-list">
          {sectionsData.map((section, index) => (
            <div className="section" key={index}>
              <h2>{section.title}</h2>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  );
};

export default About;
